__webpack_require__.p = "https://zcoasystem.obs.cn-east-3.myhuaweicloud.com/qdfb/pc-front-end-shell/2026032101/";